import $ from 'jquery';
import 'slick-carousel';

ready(qs('.CP-jobs-wrapper'), () => {
    const $mainWrapper = document.querySelector('.main-wrapper')
    const $pushes = qsa('.CP-jobs-wrapper .main-push');
    const subWrappers = $('.CP-jobs-wrapper .sub-wrapper');
    const $subWrappers = qsa('.CP-jobs-wrapper .sub-wrapper');
    const $plusBtn = qs('.CP-jobs-wrapper .CP-plus');
    const settings_m = {
        arrows: false,
        dots: false,
        // variableWidth: true,
    };
    const settings_d = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        variableWidth: true,
    };
    const settings_d_special = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        variableWidth: true,
    };
    $subWrappers.forEach((push, i) => {
        if (push.querySelector('li') == null) {
            push.parentNode.querySelector('.plus').style.display = 'none'
        }
        if (push.querySelectorAll('li').length === 2 && window.innerWidth > 1024) {
            push.querySelectorAll('li').forEach(x => x.style.width = '50%')
            setTimeout(() =>$(push).slick('unslick'), 2000);
        }
        //     warn()
        // }
    })
    $pushes.forEach((push, i) => {
        const $btn = push.querySelector('button');
        $btn.index = i;

        ael($btn, 'click', () => {
            const $wrapper = push.querySelector('.sub-wrapper');
            push.isOpened = push.isOpened || false;
            push.defaultMarginBottom = 60;

            //Reset
            $pushes.forEach(el => qs(el, 'button').className = "plus")
            $subWrappers.forEach(el => el.classList.remove('wrapper-active'))
            $pushes.forEach(el => {
                el.querySelector('.push').classList.remove('push-active');
                el.style.marginBottom = push.defaultMarginBottom + "px";
            })

            if (!push.isOpened) {
                //Ouverture
                $btn.classList.add('minus');
                $wrapper.classList.add('wrapper-active');
                push.querySelector('.push').classList.add('push-active');

                if (window.innerWidth < 1024) {
                    window.scrollTo(0, $wrapper.offsetTop - 150);
                } else {
                    $wrapper.style.top = (push.offsetTop + push.clientHeight) + "px";
                    $wrapper.style.left = ($pushes[0].offsetLeft) + "px";
                    $wrapper.style.width = (window.innerWidth - $pushes[0].offsetLeft - 17) + "px";

                    for (let index = $btn.index - $btn.index % 3, j = 0; j < 3 && index < $pushes.length; index++ , j++) {
                        $pushes[index].style.marginBottom = (push.defaultMarginBottom + $wrapper.clientHeight) + "px";
                    }

                }

                if (!$wrapper.isSlicked) {
                    $wrapper.isSlicked = true;
                    if ($wrapper.querySelectorAll('li').length === 2) {
                        $($wrapper).slick(window.innerWidth < 1024 ? settings_m : settings_d_special);
                    } else {
                        $($wrapper).slick(window.innerWidth < 1024 ? settings_m : settings_d);
                    }
                }

                $pushes.forEach(el => el.isOpened = false)
                push.isOpened = true;

            } else {
                //Fermeture
                push.isOpened = false;
            }
        })
    })

    ael($plusBtn, 'click', () => {
        $pushes.forEach(el => el.style.display = 'block');
        $plusBtn.style.display = 'none'
    })

    window.onresize = () => {
        var $wrapper = document.querySelector(".sub-wrapper.wrapper-active");
        if ($wrapper) {
            var push = $wrapper.parentElement;
            const $btn = push.querySelector('button');

            if (window.innerWidth >= 1024) {
                $wrapper.style.top = (push.offsetTop + push.clientHeight) + "px";
                $wrapper.style.left = ($pushes[0].offsetLeft) + "px";
                $wrapper.style.width = (window.innerWidth - $pushes[0].offsetLeft - 17) + "px";

                for (let index = $btn.index - $btn.index % 3, j = 0; j < 3 && index < $pushes.length; index++ , j++) {
                    $pushes[index].style.marginBottom = (push.defaultMarginBottom + $wrapper.clientHeight) + "px";
                }

            } else {
                $wrapper.style.top = "";
                $wrapper.style.left = "";
                $wrapper.style.width = "";

                for (let index = $btn.index - $btn.index % 3, j = 0; j < 3 && index < $pushes.length; index++ , j++) {
                    $pushes[index].style.marginBottom = "";
                }
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/scripts/components/JobsSubWrapper.js